import type { SessionSettings } from '@/types/chat'

export function buildSettingsBadge(settings: SessionSettings): string {
  const parts: string[] = []

  if (settings.temperature !== undefined) {
    parts.push(`T=${formatDecimal(settings.temperature)}`)
  }

  if (settings.topP !== undefined) {
    parts.push(`top_p=${formatDecimal(settings.topP)}`)
  }

  if (settings.maxTokens !== undefined) {
    parts.push(`max=${settings.maxTokens}`)
  }

  parts.push(settings.jsonMode ? 'JSON=on' : 'JSON=off')

  if (settings.seed !== undefined) {
    parts.push(`seed=${settings.seed}`)
  } else {
    parts.push('seed=—')
  }

  return parts.join(' ')
}

export function mergeSettings(
  defaults: SessionSettings,
  override?: SessionSettings,
): SessionSettings {
  if (!override) return { ...defaults }

  return {
    temperature: override.temperature ?? defaults.temperature,
    topP: override.topP ?? defaults.topP,
    maxTokens: override.maxTokens ?? defaults.maxTokens,
    frequencyPenalty: override.frequencyPenalty ?? defaults.frequencyPenalty,
    presencePenalty: override.presencePenalty ?? defaults.presencePenalty,
    seed: override.seed ?? defaults.seed,
    responseFormat: override.responseFormat ?? defaults.responseFormat,
    jsonMode: override.jsonMode ?? defaults.jsonMode,
  }
}

function formatDecimal(value: number): string {
  return Number.isInteger(value) ? String(value) : value.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')
}
